import React from "react";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import IconButton from "@material-ui/core/IconButton";
import { socialIdClients } from "../../constants";

const FacebookIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="22" fill="#1877f3" />
    <path
      d="M24.5 33V23.5h3.2l.48-3.7h-3.68v-2.36c0-1.07.3-1.8 1.84-1.8h1.97V12.3c-.34-.05-1.5-.15-2.85-.15-2.82 0-4.75 1.72-4.75 4.89v2.76h-3.19v3.7h3.19V33h3.79z"
      fill="#fff"
      transform="translate(-1.5,0)"
    />
  </svg>
);

export const FacebookLoginButton = ({ handleFacebookLogin, programa }) => {
  const handleLogin = response => {
    handleFacebookLogin(response, programa);
  };

  return (
    <FacebookLogin
      appId={socialIdClients.facebook}
      fields="name,email,picture,first_name,last_name"
      callback={handleLogin}
      render={renderProps => (
        <IconButton
          onClick={renderProps.onClick}
          style={{
            backgroundColor: "transparent",
            margin: "0 8px",
            width: 40,
            height: 40,
            padding: 0
          }}
        >
          <FacebookIcon />
        </IconButton>
      )}
    />
  );
};
